import {
  BooleanInput,
  CheckboxGroupInput,
  DateField,
  Filter,
  FunctionField,
  SelectInput,
  TextField,
  TextInput,
} from 'react-admin'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { CustomBooleanField } from '../../components/Fields'
import {
  BACKGROUND_CHECK_REPORT_STATUS_CHOICES,
  BundleChoices,
  CarrierMCChoices,
  DRIVER_STATUS_CHOICES,
  REFERRAL_SOURCE_CHOICES,
  TEAM_COMPOSITION_CHOICES,
} from '../../helpers/constants'
import { getTeamAndProductName } from '../../helpers/utils'
import { ProductSubscriptionStripeStatus } from '../../models/productSubscription'
import { ProductSubscriptionBundleName } from '../../models/subscription'
import { CustomReferenceField } from '../Common/CustomReferenceFields'
import { CTDatagrid } from '../CTDatagrid'
import CTList from '../List'
import { TeamStripeSubscriptionStatus } from '../Teams/TeamStripeSubscription'

const UserFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <BooleanInput label="Is Team Driver" source="is_team_driver" />
    <BooleanInput label="Is Team Admin" source="is_team_admin" />
    <SelectInput label="Team Composition" source="team__composition" choices={TEAM_COMPOSITION_CHOICES} />
    <SelectInput
      label="Bg-check status"
      source="background_check"
      choices={BACKGROUND_CHECK_REPORT_STATUS_CHOICES}
    />
    <CheckboxGroupInput
      label="Referral source"
      source="team__referral_source"
      choices={REFERRAL_SOURCE_CHOICES}
    />
    <SelectInput label="Driver status" source="driver_status" choices={DRIVER_STATUS_CHOICES} />
    <SelectInput label="Product Subscription" source="product_name" choices={BundleChoices} />
    <SelectInput
      label="Carrier"
      source="team__latest_product_subscription__carrier__mc_number"
      choices={CarrierMCChoices}
    />
  </Filter>
)

const UserList = (props: any) => {
  usePageTitle('Users')

  return (
    <CTList bulkActionButtons={false} filters={<UserFilter />} {...props}>
      <CTDatagrid optimized>
        <TextField source="first_name" />
        <TextField source="last_name" />
        <TextField source="email" />
        <TextField source="mobile" />
        <FunctionField
          label="Team (Product)"
          render={(record: any) => (
            <FlexBox gap="10px" alignItems="center">
              <CustomReferenceField
                record={record}
                source="team"
                label="Team (Product)"
                sortable={false}
                baseUrl="/teams"
                representationFunction={getTeamAndProductName}
              />
              {(record?.team?.stripe_subscription_status !== ProductSubscriptionStripeStatus.NOT_APPLICABLE ||
                record.product_subscription_name === ProductSubscriptionBundleName.FLEX_STARTER) && (
                <div>
                  <TeamStripeSubscriptionStatus
                    status={record?.team?.stripe_subscription_status}
                    size="small"
                  />
                </div>
              )}
            </FlexBox>
          )}
        />
        <TextField label="Carrier" source="team.carrier_name" />
        <CustomBooleanField label="Team Status" source="team.is_approved" />
        <DateField source="date_joined" options={{ timeZoneName: 'short' }} />
        <CustomBooleanField source="is_team_admin" />
        <CustomBooleanField source="is_team_driver" />
        <TextField source="driver_status" />
      </CTDatagrid>
    </CTList>
  )
}

export default UserList
